import styled from "styled-components";
import { ManagerSearchButton } from "./search-button";
// tslint:disable-next-line
export const ManagerSearchFilterSearchButton = styled(ManagerSearchButton)`
  left: 380px;
`;
